exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.round-input[data-v-02ef2b8e]{\n    border-radius: 0.25em !important;\n}\n.wpp-call[data-v-02ef2b8e]{\n    margin-top: 1em;\n}\n.wpp-call[data-v-02ef2b8e]:hover{\n    color: gray;\n}\n", ""]);

// exports
